import React from "react";
import ReactPlayer from 'react-player'
import "./css/video.css";

const Video = ({ url, maxHeight }) => {
    return (
        <div className="video-wrapper" style={{ maxHeight: maxHeight }}>
            <ReactPlayer
                url={url}
                controls
                width="100%"
                height="100%"
            />
        </div>
    );
}

export default Video;
